
import request from '../../../helpers/request';

const createCounterpartyAttachments = async (id, files = []) => {
  await Promise.all(
    files.map(async (file) => {
      const formData = new FormData();
      formData.append('file', file);
      return request.post(
        `/RentPlace/counterparty/${id}/attachment`,
        formData,
        'При загрузке изображения произошла ошибка'
      );
    })
  );
};

export default createCounterpartyAttachments;
